{
  "MENU_TOGGLE": "Menu",
  "NAVIGATION": {
    "TABS": {
      "GET_STARTED": "Get Started",
      "HOME": "Home",
      "FULFILLMENT": "Projects",
      "DASHBOARD": "Dashboard",
      "RECENT_ACTIVITY": "Recent Activity",
      "EXECUTIVE_REPORT": "Executive Report",
      "MULTI_LOCATION_REPORT": "Executive Report",
      "RECOMMENDATIONS": "Recommendations",
      "MY_PRODUCTS": "My Products",
      "STORE": "Store",
      "CUSTOMER_LIST": "Customers",
      "GUIDES": "Guides",
      "ALL": "All",
      "BRANDS": "Groups",
      "GROUPS": "Groups",
      "LOCATIONS": "Locations",
      "FILES": "Files",
      "SETTINGS": "Settings",
      "BUSINESS_PROFILE": "Business Profile",
      "INVITE_USERS": "Invite Users",
      "USER_PROFILE": "User Profile",
      "NOTIFICATION_SETTINGS": "Notification Settings",
      "BILLING_SETTINGS": "Billing Settings",
      "INVOICES": "Invoices",
      "MANAGE_RECIPIENTS": "Manage Recipients",
      "SOCIAL_CONNECTIONS": "Connections",
      "MY_LISTING": "My Listing",
      "MEETING_SCHEDULER": "My Meetings",
      "INBOX": "Conversations Messages",
      "INBOX_AI": "Chat with {{ assistantName }}",
      "ORDERS": "Orders",
      "EMAIL_HISTORY": "Email History",
      "EMAIL_CONFIGURATION": "Email configuration",
      "MANAGE_REVIEWS": "Manage Reviews",
      "REVIEWS": "Reviews",
      "CRM": {
        "CRM": "CRM",
        "COMPANY": "Companies",
        "CONTACT": "Contacts",
        "SALES_TASKS": "Tasks",
        "OPPORTUNITIES": "Opportunities",
        "ACTIVITY_FEED": "Activity feed"
      },
      "PAYMENTS": {
        "PAYMENTS": "Payments",
        "INVOICES": "Invoices",
        "PAYOUTS": "Payouts"
      },
      "LEADERBOARD": "Leaderboard",
      "DYNAMIC_LISTS": "Lists",
      "LEAD_SCORING": "Score",
      "LEAD_SCORING_DESCRIPTION": "Configure scoring rules based on behavioural and fit attributes",
      "CUSTOM_FORMS": "Forms",
      "INBOX_SETTINGS": "Conversations settings",
      "INBOX_SETTINGS_DESCRIPTION": "Connect and manage Conversations channels, set up AI responders, and manage message templates",
      "AI_KNOWLEDGE_SETTINGS": "Knowledge base",
      "AI_KNOWLEDGE_SETTINGS_DESCRIPTION": "Manage a central library of knowledge to utilize across AI features",
      "AI_ASSISTANTS": "Workforce",
      "AI_CAPABILITIES": "Capabilities",
      "AI_PROJECTS": "Projects",
      "AI_VIBE": "Vibe",
      "NEW_VIBE": "New Vibe",
      "AI": "AI",
      "AI_ASSISTANTS_SETTINGS_DESCRIPTION": "Create, configure, and assign AI bots to help your business",
      "WEBCHAT_CONFIGURATION": "Web Chat configuration",
      "CAMPAIGNS": "Campaigns",
      "ALL_CAMPAIGNS": "All campaigns",
      "EMAIL_TEMPLATES": "Email templates",
      "AUTOMATIONS": "Automations",
      "ADMINISTRATION": "Administration",
      "FIELD_MANAGEMENT_SETTINGS": "CRM objects",
      "FIELD_MANAGEMENT_SETTINGS_DESCRIPTION": "View and manage your standard objects, including contacts, companies, and more."
    },
    "PINNED_PRODUCTS": "Products",
    "MY_BUSINESS": "My Business",
    "MENU": {
      "EDIT_PROFILE": "Edit Profile",
      "INVITE_USERS": "Invite Users",
      "SIGN_OUT": "Sign Out",
      "SMB_INVITE": "Invite a Business",
      "STOP_IMPERSONATING": "Stop Impersonating"
    }
  },
  "NAV": {
    "PRO_CHIP": "Pro"
  },
  "COMMON": {
    "BETA": "Beta",
    "KEYBOARD": {
      "SHIFT": "Shift",
      "ESC": "Esc"
    },
    "ACTION_LABELS": {
      "CANCEL": "Cancel",
      "SEND": "Send",
      "CONTACT_US": "Contact Us"
    },
    "RESULT": {
      "SUCCESS": "Success",
      "FAILURE": "Something went wrong, please try again",
      "CANNOT_BE_IMPERSONATED": "You cannot send a message because you are an Admin"
    },
    "CONTACT_SALESPERSON": "Contact {{ salesPersonName }}",
    "POWERED_BY": "Powered by",
    "BOOK_A_MEETING": "Book a meeting"
  },
  "SWITCH_LOCATION_MODAL": {
    "ADMIN_VIEW": "You are an admin, so you may see accounts not available to all users.",
    "DEFAULT": "DEFAULT",
    "SELECT_LOCATION": "Select Location",
    "SELECT_DEFAULT": "Select the account you'd like to view. You can skip this step in the future by setting an account as your default.",
    "MAKE_DEFAULT": "Make Default",
    "NO_LOCATIONS": "No Locations For:",
    "TO_SELECT": "to Select",
    "TO_NAVIGATE": "to Navigate",
    "TO_CHANGE_TABS": "to Change Tabs",
    "TO_CLOSE": "to Close",
    "TO_OPEN": "to Open",
    "EMPTY_STATES": {
      "TITLE": "You don’t have access to any",
      "MESSAGE": "To view insights, use products, and take your business to the next level, you’ll first need access to a location or group.",
      "ALL_TAB_NAME": "Locations or Groups",
      "CONTACT": "Contact your administrator to grant you access."
    },
    "SEARCH": "Search location name or address",
    "NO_SEARCH_RESULT": {
      "TITLE": "No results found",
      "MESSAGE": "Try adjusting your search terms to find what you’re looking for."
    }
  },
  "REQUEST_ASSISTANCE_MODAL": {
    "COMPOSE_MESSAGE": "Compose Message"
  },
  "USER_REQUIRED_MODAL": {
    "TITLE": "Account access required",
    "DESCRIPTION": "Only users belonging to this customer’s account can access this product."
  },
  "PERFORMANCE": {
    "MULTI_LOCATION": {
      "PAGE_TITLES": {
        "ADVERTISING": "Advertising",
        "DASHBOARD": "Dashboard",
        "DATA_EXPORT": "Data Exporter",
        "GOOGLE_MY_BUSINESS": "Google Business Profile",
        "GOOGLE_Q_AND_A": "Google Q&A",
        "INSIGHTS": "Insights",
        "LISTINGS": "Listings",
        "MANAGE_LISTINGS": "Manage Listings",
        "MANAGE_POSTS": "Manage Posts",
        "MANAGE_REVIEWS": "Manage Reviews",
        "MANAGE": "Manage",
        "OVERVIEW": "Overview",
        "REPUTATION": "Reputation",
        "REVIEWS": "Reviews",
        "SENTIMENT_ANALYSIS": "Sentiment Analysis",
        "SOCIAL": "Social",
        "CONTACTS": "Contacts",
        "TASKS": "Tasks"
      }
    }
  },
  "SM_NAV": {
    "SOCIAL": "Social",
    "OVERVIEW": "Overview",
    "MY_POSTS": "My Posts",
    "RECENT_POSTS": "Recent Posts",
    "SCHEDULED_POSTS": "Scheduled Posts",
    "CALENDAR": "Calendar",
    "DRAFTS": "Drafts",
    "TEMPLATES": "Templates",
    "CUSTOMER_POSTS": "Customer Posts",
    "LEADS": "Leads",
    "CONTENT": "Content",
    "ANALYTICS": "Analytics",
    "INSIGHTS": "Insights",
    "ANALYTICS_OVERVIEW": "Overview",
    "LINK_PERFORMANCE": "Link Performance",
    "FACEBOOK_INSIGHTS": "Facebook Insights",
    "POST_PERFORMANCE": "Post Performance",
    "SETTINGS": "Settings",
    "CONNECT_ACCOUNTS": "Connect Accounts",
    "LEAD_SEARCHES": "Lead Searches",
    "LEAD_RESPONSES": "Lead Responses",
    "INTERESTING_CONTENT": "Interesting Content"
  },
  "RM_NAV": {
    "REPUTATION": "Reputation",
    "OVERVIEW": "Overview",
    "REVIEWS": "Reviews",
    "REVIEWS_MANAGE": "Manage Reviews",
    "REVIEWS_WIDGET": "Review Display Widget",
    "LISTINGS": "Listings",
    "LISTINGS_PRIMARY": "Primary Listings",
    "LISTINGS_CITATIONS": "Citations",
    "STATISTICS": "Statistics",
    "COMPETITION": "Competition",
    "MENTIONS": "Mentions",
    "MENTIONS_MONITOR": "Monitor Mentions",
    "MENTIONS_TIMELINE": "Mentions Timeline",
    "SOCIAL": "Social",
    "SOCIAL_MONITORING": "Social Monitoring",
    "SOCIAL_EMPLOYEE_MONITORING": "Employee Monitoring",
    "SOCIAL_STATISTICS": "Social Statistics",
    "REPORTS": "Reports",
    "SETTINGS": "Settings",
    "SETTINGS_CONNECT_ACCOUNTS": "Connect Accounts",
    "SETTINGS_REVIEW_WIDGET": "Review Widget",
    "SETTINGS_LISTINGS": "Listings",
    "SETTINGS_COMPETITION": "Competition",
    "SETTINGS_MENTIONS": "Mentions",
    "SETTINGS_REPORTS": "Reports",
    "SETTINGS_RESPONSE_TEMPLATES": "Response Templates"
  },
  "CV_NAV": {
    "CUSTOMER_VOICE": "Customer Voice",
    "OVERVIEW": "Overview",
    "CUSTOMERS": "Customers",
    "Templates": "Templates",
    "WIDGET": "Widget",
    "SETTINGS": "Settings",
    "REVIEW_PAGE_URLS": "Review Page URLs",
    "CONFIRMATION_MESSAGES": "Confirmation Messages",
    "PREFERRED_REVIEW_SITES": "Preferred Review Sites"
  }
}
